export default __webpack_public_path__ + "static/media/event-action-email.b5717d47.svg";